import { render, staticRenderFns } from "./treeList.vue?vue&type=template&id=5984c3ea&scoped=true&"
import script from "./treeList.vue?vue&type=script&lang=js&"
export * from "./treeList.vue?vue&type=script&lang=js&"
import style0 from "./treeList.vue?vue&type=style&index=0&id=5984c3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984c3ea",
  null
  
)

export default component.exports